import React from 'react';
import RowDeleteButton from '../../components/ActionButtons/RowDeleteButton';
import RowEditButton from '../../components/ActionButtons/RowEditButton';
import RowLogButton from '../../components/ActionButtons/RowLogButton';
import RowStartButton from '../../components/ActionButtons/RowStartButton';
import RowStopButton from '../../components/ActionButtons/RowStopButton';
import MonitorIcon from '../../components/MonitorIcon/MonitorIcon';
import StrategyUsageBadge from '../../components/StrategyUsageBadge/StrategyUsageBadge';
import HealthDot from '../../components/HealthDot/HealthDot';
import { getMonitorTypeLabel } from '../../utils/MonitorUtils';

/**
 * props:
 * - data
 * - usages: [{ id, name }] (opcional)
 * - onEditClick
 * - onStopClick
 * - onStartClick
 * - onDeleteClick
 * - onLogsClick
 */
function MonitorRow(props) {

    function getStatusClass(isActive) {
        return isActive ? 'text-success' : 'text-danger';
    }

    function getStatusText(isActive) {
        return isActive ? 'Ativo' : 'Parado';
    }

    return (
        <tr className="align-middle">
            <td>
                <HealthDot health={props.health} />
                <MonitorIcon data={props.data} />
                {getMonitorTypeLabel(props.data.type)}
            </td>
            <td>
                {
                    props.data.symbol
                        ? props.data.symbol
                        : '*'
                }
                {
                    props.data.interval
                        ? `_${props.data.interval}`
                        : ''
                }
                <StrategyUsageBadge usages={props.usages} />
            </td>
            <td>
                <span className={getStatusClass(props.data.isActive)}>
                    {getStatusText(props.data.isActive)}
                </span>
            </td>
            <td>
                <RowEditButton id={props.data.id} title='Editar este Monitor' modalId='modalMonitor' onClick={props.onEditClick} showButton={!props.data.isSystemMon} />
                <RowStopButton id={props.data.id} title='Parar este Monitor' onClick={props.onStopClick} showButton={props.data.isActive && !props.data.isSystemMon} />
                <RowStartButton id={props.data.id} title='Iniciar este Monitor' onClick={props.onStartClick} showButton={!props.data.isActive && !props.data.isSystemMon} />
                <RowDeleteButton id={props.data.id} title='Excluir este Monitor' onClick={props.onDeleteClick} showButton={!props.data.isActive && !props.data.isSystemMon} />
                <RowLogButton id={props.data.id} title='Logs deste Monitor' onClick={props.onLogsClick} showButton={props.data.isSystemMon} />
            </td>
        </tr>
    );
}

export default MonitorRow;